/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Deck_Phase_OpenInputs */



/**
* | output |
* | --- |
* | "Open for submissions" |
*
* @param {Tournaments_Lib_Deck_Phase_OpenInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_deck_phase_open = /** @type {((inputs?: Tournaments_Lib_Deck_Phase_OpenInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Deck_Phase_OpenInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Offen für Einreichungen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvert aux soumissions")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("开放提交")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("開放提交")
	if (locale === "ko") return /** @type {LocalizedString} */ ("제출 받는 중")
	return /** @type {LocalizedString} */ ("Open for submissions")
});